module.exports = __webpack_public_path__ + "img/20190601135425QQ截图20190527164352.63c8b21d.png";